export const HspQuizLogEvent = {
  // [HSP퀴즈 - 랜딩] 화면 진입
  HSP_QUIZ_LANDING_PAGE_VIEWED: {
    amp: 'HSP Quiz Landing - Page Viewed',
    ga: 'hsp_quiz_landing_page_viewed',
  },
  // [HSP퀴즈 - 랜딩] 시작 버튼 클릭
  HSP_QUIZ_LANDING_START_BUTTON_CLICKED: {
    amp: 'HSP Quiz Landing - Start Button Clicked',
    ga: 'hsp_quiz_landing_start_button_clicked',
  },
  // [HSP퀴즈 - 랜딩] - HSP 궁금하다면 버튼 클릭
  HSP_QUIZ_LANDING_ABOUT_HSP_BUTTON_CLICKED: {
    amp: 'HSP Quiz Landing - About HSP Button Clicked',
    ga: 'hsp_quiz_landing_about_hsp_button_clicked',
  },
  // [HSP퀴즈 - 생성] 화면 진입
  HSP_QUIZ_CREATION_PAGE_VIEWED: {
    amp: 'HSP Quiz Creation - Page Viewed',
    ga: 'hsp_quiz_creation_page_viewed',
  },
  // [HSP퀴즈 - 생성] 다음 버튼 클릭
  HSP_QUIZ_CREATION_NEXT_BUTTON_CLICKED: {
    amp: 'HSP Quiz Creation - Next Button Clicked',
    ga: 'hsp_quiz_creation_next_button_clicked',
  },
  // [HSP퀴즈 - 응답] 화면 진입
  HSP_QUIZ_REPLY_PAGE_VIEWED: {
    amp: 'HSP Quiz Reply - Page Viewed',
    ga: 'hsp_quiz_reply_page_viewed',
  },
  // [HSP퀴즈 - 응답] 다음 버튼 클릭
  HSP_QUIZ_REPLY_NEXT_BUTTON_CLICKED: {
    amp: 'HSP Quiz Reply - Next Button Clicked',
    ga: 'hsp_quiz_reply_next_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 화면 진입
  HSP_HOST_QUIZ_REPORT_PAGE_VIEWED: {
    amp: 'HSP Host Quiz Report - Page Viewed',
    ga: 'hsp_host_quiz_report_page_viewed',
  },
  // (Web Only) [HSP호스트퀴즈리포트] - 저장하기 클릭
  HSP_HOST_QUIZ_REPORT_SAVE_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Save Button Clicked',
    ga: 'hsp_host_quiz_report_save_button_clicked',
  },
  // (Web Only) [HSP호스트퀴즈리포트] - 타입스 앱으로 이용하기 클릭
  HSP_HOST_QUIZ_REPORT_USE_APP_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Use App Button Clicked',
    ga: 'hsp_host_quiz_report_use_app_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 내 테스트 결과 탭 클릭
  HSP_HOST_QUIZ_REPORT_MY_TEST_RESULT_TAB_CLICKED: {
    amp: 'HSP Host Quiz Report - My Test Result Tab Clicked',
    ga: 'hsp_host_quiz_report_my_test_result_tab_clicked',
  },
  // [HSP호스트퀴즈리포트] - 친구들이 보는 나 탭 클릭
  HSP_HOST_QUIZ_REPORT_REPLY_LIST_TAB_CLICKED: {
    amp: 'HSP Host Quiz Report - Reply List Tab Clicked',
    ga: 'hsp_host_quiz_report_reply_list_tab_clicked',
  },
  // [HSP호스트퀴즈리포트] - 민감성 유형별 요약 설명 클릭
  HSP_HOST_QUIZ_REPORT_SUMMARY_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED: {
    amp: 'HSP Host Quiz Report - Summary Description By Type Of Sensitivity Clicked',
    ga: 'hsp_host_quiz_report_summary_description_by_type_of_sensitivity_clicked',
  },
  // [HSP호스트퀴즈리포트] - 남들이 보는 나는 어떤지 확인하고 싶다면 클릭
  HSP_HOST_QUIZ_REPORT_NAVIGATE_TO_REPLY_LIST_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Navigate To Reply List Button Clicked',
    ga: 'hsp_host_quiz_report_navigate_to_reply_list_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 내 MBTI 확인하기 클릭
  HSP_HOST_QUIZ_REPORT_CHECK_MY_MBTI_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Check My MBTI Button Clicked',
    ga: 'hsp_host_quiz_report_check_my_mbti_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 테스트 공유 버튼 클릭 (하단 linear 공유)
  HSP_HOST_QUIZ_REPORT_SHARE_TEST_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Share Test Button Clicked',
    ga: 'hsp_host_quiz_report_share_test_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 민감한 특징 상세 클릭 (내가 가진 민감한 특징, 다른 민감한 특징들)
  HSP_HOST_QUIZ_REPORT_DETAILED_SENSITIVE_FEATURES_CLICKED: {
    amp: 'HSP Host Quiz Report - Detailed Sensitive Features Clicked',
    ga: 'hsp_host_quiz_report_detailed_sensitive_features_clicked',
  },
  // [HSP호스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  HSP_HOST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED: {
    amp: 'HSP Host Quiz Report - Sensitivity Rating Clicked',
    ga: 'hsp_host_quiz_report_sensitivity_rating_clicked',
  },
  // [HSP호스트퀴즈리포트] - 퀴즈 공유하기 클릭 (상단 공유)
  HSP_HOST_QUIZ_REPORT_SHARE_QUIZ_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Share Quiz Button Clicked',
    ga: 'hsp_host_quiz_report_share_quiz_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 링크 복사 클릭 (상단 공유)
  HSP_HOST_QUIZ_REPORT_COPY_LINK_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Copy Link Button Clicked',
    ga: 'hsp_host_quiz_report_copy_link_button_clicked',
  },
  // [HSP호스트퀴즈리포트] -  QR 공유 클릭 (상단 공유)
  HSP_HOST_QUIZ_REPORT_QR_CODE_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - QR Code Button Clicked',
    ga: 'hsp_host_quiz_report_qr_code_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 응답 클릭
  HSP_HOST_QUIZ_REPORT_REPLY_CLICKED: {
    amp: 'HSP Host Quiz Report - Reply Clicked',
    ga: 'hsp_host_quiz_report_reply_clicked',
  },
  // [HSP호스트퀴즈리포트] - 자세히 탐구하기 클릭
  HSP_HOST_QUIZ_REPORT_INVESTIGATE_DEEPLY_CLICKED: {
    amp: 'HSP Host Quiz Report - Investigate Deeply Clicked',
    ga: 'hsp_host_quiz_report_investigate_deeply_clicked',
  },
  // [HSP게스트퀴즈리포트] - 화면 진입
  HSP_GUEST_QUIZ_REPORT_PAGE_VIEWED: {
    amp: 'HSP Guest Quiz Report - Page Viewed',
    ga: 'hsp_guest_quiz_report_page_viewed',
  },
  // [HSP게스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  HSP_GUEST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED: {
    amp: 'HSP Guest Quiz Report - Sensitivity Rating Clicked',
    ga: 'hsp_guest_quiz_report_sensitivity_rating_clicked',
  },
  // [HSP게스트퀴즈리포트] - HSP 설명 자세히 보기 클릭
  HSP_GUEST_QUIZ_REPORT_VIEW_DETAILED_DESCRIPTION_CLICKED: {
    amp: 'HSP Guest Quiz Report - View Detailed Description Clicked',
    ga: 'hsp_guest_quiz_report_view_detailed_description_clicked',
  },
  // [HSP게스트퀴즈리포트] - 모든응답 page 버튼 클릭
  HSP_GUEST_QUIZ_REPORT_ALL_REPLY_PAGE_BUTTON_CLICKED: {
    amp: 'HSP Guest Quiz Report - All Reply Page Button Clicked',
    ga: 'hsp_guest_quiz_report_all_reply_page_button_clicked',
  },
  // [HSP게스트퀴즈리포트] - 민감성 유형별 설명 클릭
  HSP_GUEST_QUIZ_REPORT_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED: {
    amp: 'HSP Guest Quiz Report - Description By Type Of Sensitivity Clicked',
    ga: 'hsp_guest_quiz_report_description_by_type_of_sensitivity_clicked',
  },
  // [HSP게스트퀴즈리포트] - 내 민감도 레벨 확인하기 버튼 클릭
  HSP_GUEST_QUIZ_REPORT_CHECK_MY_SENSITIVITY_LEVEL_BUTTON_CLICKED: {
    amp: 'HSP Guest Quiz Report - Check My Sensitivity Level Button Clicked',
    ga: 'hsp_guest_quiz_report_check_my_sensitivity_level_button_clicked',
  },
  // [HSP설명] - 화면 진입
  HSP_DESCRIPTION_PAGE_VIEWED: {
    amp: 'HSP Description - Page Viewed',
    ga: 'hsp_description_page_viewed',
  },
  // [HSP 민감한 특징들 설명] - 화면 진입
  HSP_DESCRIPTION_SENSITIVE_FEATURES_PAGE_VIEWED: {
    amp: 'HSP Description Sensitive Features - Page Viewed',
    ga: 'hsp_description_sensitive_features_page_viewed',
  },
  // [HSP 민감한 특징들 설명] - 강점/약점 펼쳐보기 클릭
  HSP_DESCRIPTION_SENSITIVE_FEATURES_STRENGTHS_AND_WEAKNESSES_EXPAND_CLICKED: {
    amp: 'HSP Description Sensitive Features - Strengths And Weaknesses Expand Clicked',
    ga: 'hsp_description_sensitive_features_strengths_and_weaknesses_expand_clicked',
  },
  // [HSP 민감한 특징들 설명] - 친구에게도 이 테스트 알려주기 클릭
  HSP_DESCRIPTION_SENSITIVE_FEATURES_SHARE_TEST_BUTTON_CLICKED: {
    amp: 'HSP Description Sensitive Features - Share Test Button Clicked',
    ga: 'hsp_description_sensitive_features_share_test_button_clicked',
  },
  // [HSP 민감한 특징들 설명] - 더 구체적인 내용 탐색해보기 클릭
  HSP_DESCRIPTION_SENSITIVE_FEATURES_INVESTIGATE_DEEPLY_CLICKED: {
    amp: 'HSP Description Sensitive Features - Investigate Deeply Clicked',
    ga: 'hsp_description_sensitive_features_investigate_deeply_clicked',
  },

  // [HSP 이미 푼 퀴즈 선택] - 화면 진입
  HSP_QUIZ_SELECT_PAGE_VIEWED: {
    amp: 'HSP Quiz Select - Page Viewed',
    ga: 'hsp_quiz_select_page_viewed',
  },
  // [HSP 이미 푼 퀴즈 선택] - 새로 만들기 클릭
  HSP_QUIZ_SELECT_CREATE_BUTTON_CLICKED: {
    amp: 'HSP Quiz Select - Create Button Clicked',
    ga: 'hsp_quiz_select_create_button_clicked',
  },
  // [HSP 이미 푼 퀴즈 선택] - 앱 설치 클릭
  HSP_QUIZ_SELECT_INSTALL_APP_BUTTON_CLICKED: {
    amp: 'HSP Quiz Select - Install App Button Clicked',
    ga: 'hsp_quiz_select_install_app_button_clicked',
  },
  // [HSP 이미 푼 퀴즈 선택] - 결과 아이템 클릭
  HSP_QUIZ_SELECT_RESULT_ITEM_CLICKED: {
    amp: 'HSP Quiz Select - Result Item Clicked',
    ga: 'hsp_quiz_select_result_item_clicked',
  },
  // [HSP호스트퀴즈리포트] - 앱에서 보기 floating 버튼 클릭
  HSP_HOST_QUIZ_REPORT_VIEW_IN_APP_FLOATING_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - View In App Floating Button Clicked',
    ga: 'hsp_host_quiz_report_view_in_app_floating_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 노출
  HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_VIEWED: {
    amp: 'HSP Host Quiz Report - Login Or Install App Modal Viewed',
    ga: 'hsp_host_quiz_report_login_or_install_app_modal_viewed',
  },
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 로그인 클릭
  HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_LOGIN_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Login Or Install App Modal Login Button Clicked',
    ga: 'hsp_host_quiz_report_login_or_install_app_modal_login_button_clicked',
  },
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_INSTALL_BUTTON_CLICKED: {
    amp: 'HSP Host Quiz Report - Login Or Install App Modal Install Button Clicked',
    ga: 'hsp_host_quiz_report_login_or_install_app_modal_install_button_clicked',
  },
  //[Hsp호스트퀴즈리포트]- MBTI 통계 노출
  HSP_HOST_QUIZ_REPORT_MBTI_STATISTICS_VIEWED: {
    amp: "HSP Host Quiz Report - Mbti Statistics Viewed",
    ga: "hsp_host_quiz_report_mbti_statistics_viewed"
  },

  //[Hsp호스트퀴즈리포트]- MBTI 변경하기 버튼 클릭
  HSP_HOST_QUIZ_REPORT_MBTI_SELECT_BUTTON_CLICKED: {
    amp: "HSP Host Quiz Report - Mbti Select Button Clicked",
    ga: "hsp_host_quiz_report_mbti_select_button_clicked"
  },

  //[Hsp Mbti 선택]- 화면 진입
  HSP_MBTI_SELECT_PAGE_VIEWED: {
    amp: "HSP Mbti Select - Page Viewed",
    ga: "hsp_mbti_select_page_viewed"
  },

  //[Hsp Mbti 선택]- Mbti 아이템 클릭
  HSP_MBTI_SELECT_MBTI_ITEM_CLICKED: {
    amp: "HSP Mbti Select - Mbti Item Clicked",
    ga: "hsp_mbti_select_mbti_item_clicked"
  },

  //[Hsp Mbti 선택]- Mbti 상세 결과 버튼 클릭
  HSP_MBTI_SELECT_MBTI_REPORT_BUTTON_CLICKED: {
    amp: "HSP Mbti Select - Mbti Report Button Clicked",
    ga: "hsp_mbti_select_mbti_report_button_clicked"
  },

  //[Hsp Mbti 선택] - 새로 만들기 클릭
  HSP_MBTI_SELECT_CREATE_NEW_BUTTON_CLICKED: {
    amp: "HSP Mbti Select - Create New Button Clicked",
    ga: "hsp_mbti_select_create_new_button_clicked"
  },

  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 노출
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_VIEWED: {
    amp: "Hsp Host Quiz Report - Types Story Banner Viewed",
    ga: "hsp_host_quiz_report_types_story_banner_viewed"
  },

  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 편지 버튼 클릭
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_LETTER_BUTTON_CLICKED: {
    amp: "Hsp Host Quiz Report - Types Story Banner Letter Button Clicked",
    ga: "hsp_host_quiz_report_types_story_banner_letter_button_clicked"
  },

  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 노트 버튼 클릭
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_NOTE_BUTTON_CLICKED: {
    amp: "Hsp Host Quiz Report - Types Story Banner Note Button Clicked",
    ga: "hsp_host_quiz_report_types_story_banner_note_button_clicked"
  },

  //[HSP호스트퀴즈리포트] - 타입스 스토리 배너 로그인/앱설치 선택 모달 노출
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_LOGIN_OR_INSTALL_APP_MODAL_VIEWED: {
    amp: "HSP Host Quiz Report - Types Story Banner Login Or Install App Modal Viewed",
    ga: "hsp_host_quiz_report_types_story_banner_login_or_install_app_modal_viewed"
  },

  //[HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 로그인 클릭
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_LOGIN_BUTTON_CLICKED: {
    amp: "HSP Host Quiz Report - Types Story Banner Login Button Clicked",
    ga: "hsp_host_quiz_report_types_story_banner_login_button_clicked"
  },

  //[HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_INSTALL_BUTTON_CLICKED: {
    amp: "HSP Host Quiz Report - Types Story Banner Install Button Clicked",
    ga: "hsp_host_quiz_report_types_story_banner_install_button_clicked"
  },

  //[타입스 스토리] - 화면 진입
  TYPES_STORY_PAGE_VIEWED: {
    amp: "Types Story - Page Viewed",
    ga: "types_story_page_viewed"
  },

  //[타입스 스토리] - 개발자 노트 버튼 클릭
  TYPES_STORY_DEVELOPERS_NOTE_BUTTON_CLICKED: {
    amp: "Types Story - Developer’s Note Button Clicked",
    ga: "types_story_developers_note_button_clicked"
  },

  //[타입스 스토리] - 앱 버튼 클릭
  TYPES_STORY_APP_BUTTON_CLICKED: {
    amp: "Types Story - App Button Clicked",
    ga: "types_story_app_button_clicked"
  },

  //[타입스 스토리] - 공유 버튼 클릭
  TYPES_STORY_SHARE_BUTTON_CLICKED: {
    amp: "Types Story - Share Button Clicked",
    ga: "types_story_share_button_clicked"
  }

}
